import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=ef8926fa&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=ef8926fa&prod&lang=less"
import style1 from "./ProjectInfo.vue?vue&type=style&index=1&id=ef8926fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8926fa",
  null
  
)

export default component.exports